/**
 * Centralised role definitions + navigation filtering.
 * Commercial role is restricted to client complaints only.
 */

export const ROLE_LABELS = {
  admin: "Administrateur",
  direction: "Direction",
  responsable_qualite: "Responsable Qualité",
  commercial: "Commercial",
  logistique: "Logistique",
  achat: "Achat",
  comptabilite: "Comptabilité",
};

export const COMMERCIAL = "commercial";

export function isCommercial(user) {
  return user?.role === COMMERCIAL;
}

/**
 * Routes commercials are ALLOWED to access.
 * Anything outside this set will be blocked / redirected for commercials.
 */
export const COMMERCIAL_ALLOWED_ROUTES = new Set([
  "/",
  "/litiges",
  // Ancienne URL, conservee tant que la redirection existe.
  "/reclamations",
  "/clients",
  "/parametres",
]);

export function isRouteAllowed(user, pathname) {
  if (!isCommercial(user)) return true;
  // Allow /reclamations/:id and /clients/:id etc.
  for (const base of COMMERCIAL_ALLOWED_ROUTES) {
    if (pathname === base) return true;
    if (base !== "/" && pathname.startsWith(base + "/")) return true;
  }
  return false;
}
